import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { sumAllBillingPlanLines } from './BespokeBillingUtils';
import { BusinessTypes, CampaignGoalEnum, DealTypes } from '../../../constants/Enums';

const InvoicingBreakdown = ({
    invoices,
    campaign,
    isSAndP,
    sumAllPropertiesLines,
    offairTotal,
    currentDeal,
    selectedGoal,
    sandPBudgetDetails
}) => {
    const { formatCurrency } = useContext(SystemSettingsContext);

    const localCampaign = campaign;
    let campaignTotal = 0;
    let commissionRate = 0;
    let campaignCommission = 0;
    let campaignTotalMinusCommission = 0;
    let billingPlanTotalNetAmount = 0;
    let stillToInvoice = 0;
    if (
        localCampaign.campaignStatusName === 'Booked' ||
        localCampaign.campaignStatusName === 'Running' ||
        localCampaign.campaignStatusName === 'Completed'
    ) {
        campaignTotal = parseFloat(campaign?.budget);
        if (isSAndP) {
            campaignTotal += parseFloat(sumAllPropertiesLines('sandPBudget'));
        }

        campaignTotal -=
            isSAndP || (currentDeal?.type === DealTypes.AGENCY && !!currentDeal?.maxValuePot)
                ? campaign?.valuePotSpend
                : 0;

        commissionRate = !campaign.barterAgencyAccountId ? campaign.commissionRate : campaign.barterCommissionRate;
        campaignCommission = (campaignTotal * commissionRate) / 100 + offairTotal?.commissionTotal;
        campaignTotalMinusCommission = campaignTotal + offairTotal?.invoiceTotal - campaignCommission;
        billingPlanTotalNetAmount = sumAllBillingPlanLines(invoices, 'netAmount');
        stillToInvoice = campaignTotalMinusCommission.toFixed(2) - billingPlanTotalNetAmount.toFixed(2);
    } else {
        if (localCampaign?.businessType?.toLowerCase() === BusinessTypes.AIRTIME.name.toLocaleLowerCase()) {
            campaignTotal = parseFloat(sandPBudgetDetails?.airtimeBudget);
        }
        if (isSAndP) {
            campaignTotal = parseFloat(sandPBudgetDetails?.budget) + parseFloat(sandPBudgetDetails?.sandPBudget);
        }

        campaignTotal -=
            isSAndP ||
            (sandPBudgetDetails?.type === DealTypes.AGENCY &&
                !!sandPBudgetDetails?.maxValuePot &&
                sandPBudgetDetails.campaignGoal.goal === CampaignGoalEnum.BUDGET)
                ? sandPBudgetDetails?.valuePotSpend
                : 0;

        commissionRate = sandPBudgetDetails?.commissionRate;
        campaignCommission = (campaignTotal * commissionRate) / 100 + offairTotal?.commissionTotal;
        campaignTotalMinusCommission = campaignTotal + offairTotal?.invoiceTotal - campaignCommission;
        billingPlanTotalNetAmount = sumAllBillingPlanLines(invoices, 'netAmount');
        stillToInvoice = campaignTotalMinusCommission.toFixed(2) - billingPlanTotalNetAmount.toFixed(2);
    }

    const invoiceBoxStyle = {
        width: 175,
        height: isSAndP ? 240 : 210,
        border: '1px solid #8a8888',
        textAlign: 'center',
        fontWeight: 'bold',
        marginLeft: 30,
        padding: 5
    };

    const invoiceBoxTextStyle = {
        display: 'block',
        fontSize: 14
    };

    const invoiceBoxAmountStyle = {
        width: 130,
        height: 30,
        fontSize: 16,
        border: '1px solid #8a8989',
        backgroundColor: stillToInvoice > 0 ? '#f7d5d5' : '#FFFFFF',
        margin: '50px auto 0 auto',
        lineHeight: '30px'
    };
    return (
        <div style={{ marginLeft: 29, marginTop: 49 }}>
            <div style={invoiceBoxStyle}>
                <span style={invoiceBoxTextStyle}>{window.translate('Still to Invoice')}</span>
                <span style={invoiceBoxTextStyle}>{window.translate('(Net of VAT)')}</span>
                <div style={invoiceBoxAmountStyle}>{isNaN(stillToInvoice) ? 0 : formatCurrency(stillToInvoice)}</div>
            </div>
        </div>
    );
};

export default InvoicingBreakdown;
